import { SLICE_NAMES } from "@app/routes/treatmentV3/store/sliceNames";

const MAX_LENGTH = 200;
const SHOW_LIMIT = 3;
const MESSAGE = "...this object is too huge for devtools look into juno-clinet/src/store/sanitizer/sanitizer.js for more details...";

const cutPart = (arr, fromBeginning) => (fromBeginning === true ? arr.slice(0, SHOW_LIMIT) : arr.slice(-SHOW_LIMIT));

const shrinkObject = (object, fromBeginning) =>
  cutPart(Object.keys(object), fromBeginning).reduce((acc, c) => {
    acc[c] = object[c];
    return acc;
  }, {});

const shrinkArray = arr => [...arr.slice(0, SHOW_LIMIT), ...arr.slice(-SHOW_LIMIT), MESSAGE];

// Due to the large amount of data in the activityLibrarySlice we are starting to see slowdowns and crashes in the redux-devtools
// To avoid these issues we introduce those sanitizers
// We replace huge activityLibrarySlice.games and activityLibrarySlice.metaData objects that contain
// 7 properties three first elements, three last element and warning message
// These changes affect only redux-devtools, so redux state still contains full data.
export const sanitizeH5PActions = (action) => {
  if (action.type.includes(`${SLICE_NAMES.ACTIVITY_LIBRARY}/fetchLibraryData/fulfilled`) && action.payload.gamesRes) {
    const { game_meta_data, games } = action.payload.gamesRes;
    if (Object.keys(games).length > MAX_LENGTH) {
      const firstElements = shrinkObject(games, true);
      const lastElements = shrinkObject(games, false);
      action.payload.gamesRes.games = { ...firstElements, ...lastElements, WARNING: MESSAGE };
    }
    if (game_meta_data.length > MAX_LENGTH) {
      action.payload.gamesRes.game_meta_data = shrinkArray(game_meta_data);
    }
  }
};

export const sanitizeH5PState = (state) => {
  const { metaData, games } = state.activityLibrarySlice;
  const gamesKeys = Object.keys(games);
  const newSlice = { ...state.activityLibrarySlice };

  if (metaData.length > MAX_LENGTH) {
    newSlice.metaData = shrinkArray(metaData);
  }

  if (gamesKeys.length > MAX_LENGTH) {
    const firstElements = shrinkObject(games, true);
    const lastElements = shrinkObject(games, false);

    newSlice.games = { ...firstElements, ...lastElements, WARNING: MESSAGE };
  }
  return { activityLibrarySlice: newSlice };
};
